enum DealStageTypes {
  BEING_PROCESSED = 'Customer Being Processed by Clever',
  CLEVER_IS_CALLING_CUSTOMER = 'Clever is Calling Customer',
  PREPARING_TO_MATCH_WITH_AGENTS = 'Preparing to Match with Agents',
  AGENT_INTRODUCED = 'Agent Introduced',
  COMMUNICATING_WITH_AGENT = 'Communicating with Agent',
  MET = 'Met',
  HOUSE_HUNTING = 'House Hunting',
  ON_MARKET = 'On Market',
  AGREEMENT_SIGNED = 'Agreement Signed',
  MAKING_OFFERS = 'Making Offers',
  UNDER_CONTRACT = 'Under Contract',
  CLOSED = 'Closed',
  NOT_USING_CLEVER_AGENT = 'Not Using Clever Agent',
  LOST_USING_ANOTHER_LENDER = 'Lost: Using Another Lender',
  LOST_UNABLE_TO_CONTACT = 'Lost: Unable to Contact',
  NEED_CORRECT_CONTACT_INFO = 'Need Correct Contact Info',
  UNKNOWN = 'Unknown',
}

enum DealStatusGroupTypes {
  ATTEMPTING_CONTACT = 'attempting-contact',
  ACTIVE_PIPELINE = 'active-pipeline',
  RELEASED = 'released',
}

const DEAL_STATUS_GROUP_LABELS: Record<DealStatusGroupTypes, string> = {
  [DealStatusGroupTypes.ATTEMPTING_CONTACT]: 'Attempting Contact',
  [DealStatusGroupTypes.ACTIVE_PIPELINE]: 'Active Pipeline',
  [DealStatusGroupTypes.RELEASED]: 'Released',
};

enum ConnectionStageTypes {
  LOST = 1,
  SEARCHING_FOR_AGENTS = 3,
  NOT_CONNECTED = 5,
  AGENT_REFERRED = 8,
  COMMUNICATING_PRE_APPOINTMENT = 9,
  COMMUNICATING_POST_APPOINTMENT = 10,
  LISTING_APPOINTMENT_SCHEDULED = 12,
  LISTING_AGREEMENT_SIGNED = 13,
  HOME_ON_MARKET = 14,
  PENDING = 15,
  AWAITING_PAYMENT = 16,
  UNDERPAID = 17,
  CLOSED = 18,
}

// API filter values. Not TransactionTypes, which is 'Buy'/'Sell' for display.
enum DealTypeFilterTypes {
  BUYER = 'buyer',
  SELLER = 'seller',
}

const DEAL_TYPE_FILTER_LABELS: Record<DealTypeFilterTypes, string> = {
  [DealTypeFilterTypes.BUYER]: 'Buyer',
  [DealTypeFilterTypes.SELLER]: 'Seller',
};

export {
  DealStageTypes,
  ConnectionStageTypes,
  DealTypeFilterTypes,
  DealStatusGroupTypes,
  DEAL_STATUS_GROUP_LABELS,
  DEAL_TYPE_FILTER_LABELS,
};
